/**
 * Created by miguel on 22/2/17.
 */
/// <reference path="../documents/DocumentListViewController.ts" />
/// <reference path="../AppHelper.ts" />

class InvoiceListViewController extends DocumentListViewController
{
    static newInstance():InvoiceListViewController {
        let vc = new InvoiceListViewController("invoice-list-view");        
        vc.initWithResource("layout/invoices/InvoiceListView.html");        
        return vc;
    }

    protected titleLabel:MUILabel = null;

    viewDidLoad(){
        super.viewDidLoad();
		
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");		
        this.addButton.setAction(this, this.addInvoice);
        
        this.filterButton.setAction(this, function() {
			AppHelper.sharedInstance().showFilterViewController(this, this.filters, this.filtersDidChange);
		});

        MIONotificationCenter.defaultCenter().addObserver(this, "InvoiceWillDelete", this.itemDeletedNotification);

        // the stripe of the cell follows what the detail view finds on the invoice
        MIONotificationCenter.defaultCenter().addObserver(this, InvoiceReviewStateHelper.didChangeNotification, this.invoiceReviewStateDidChange);
    }    

    private invoiceReviewStateDidChange(note:MIONotification){
        let invoice = note.object as Invoice;
        if (invoice == null || this._fetchedResultsController == null) return;
        let ip = this._fetchedResultsController.indexPathForObject(invoice);
        if (ip == null) return;
        let cell = this.tableView.cellAtIndexPath(ip) as InvoiceCell;
        if (cell != null) cell.item = invoice;
    }

    titleForHeaderInSection(tableView:UITableView, section:number){
        if (this.fetchedResultsController.sections.length < 2) return null;
        
        let ip = MIOIndexPath.indexForRowInSection(0, section);
        let item = this.fetchedResultsController.objectAtIndexPath(ip) as Invoice;
                
        return item.monthString;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as Invoice;
        let cell = this.newCellAtIndexPath(tableview, item, indexPath);
        cell.selected = (this.selectedItem?.identifier == item.identifier);

        return cell;
    }

    protected newCellAtIndexPath(tableView:UITableView, item:Invoice, indexPath:MIOIndexPath) : UITableViewCell {
        let cell = tableView.dequeueReusableCellWithIdentifier("InvoiceCell") as InvoiceCell;
        cell.item = item;
        return cell;
    }

    protected showSelectedItem() {
        // let vc = InvoiceDetailViewController.newInstance();
        // vc.item = this.selectedItem;
        // this.splitViewController.showDetailViewController(vc);
    }

    protected showNoItemSelected(){
        let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Invoice", NoItemSelectedViewControllerType.Invoice);
        this.splitViewController.showDetailViewController(vc);
	}
	
    get entityName():string { return "Invoice"; }
    get customPredicateFormatOnSearch():string { return null; }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;
            
        let sds = [ 
            MIOSortDescriptor.sortDescriptorWithKey("date", false), 
            MIOSortDescriptor.sortDescriptorWithKey("documentNumber", false)
        ];

        let predicates = ["deletedAt == null"]
        if (this.searchString != null) {
            let p = "documentNumber CONTAINS '" + this.searchString + "'" + " OR legalEntity.name CONTAINS '" + this.searchString + "'";
            if (this.customPredicateFormatOnSearch != null) p += "OR " + this.customPredicateFormatOnSearch;
            predicates.addObject ("(" + p + ")");
        }
        if (this.dateTimeFrom != null && this.dateTimeTo != null) {
            predicates.addObject ("(date >= '" + this.dateTimeFrom + "' AND date <= '" + this.dateTimeTo + "')");
		}
		if (this.filterPredicateFormat != null) {
            predicates.addObject( this.filterPredicateFormat );
        }
                
        let predicateFormat = predicates.join(" AND ");
    
        let fetchRequest = DBHelper.listFetchRequestWithEntityName(this.entityName, sds, predicateFormat);
        fetchRequest.fetchLimit = 500;
        fetchRequest.relationshipKeyPathsForPrefetching = ["legalEntity", "nextDocument"];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "sectionDateString");
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }

    private dateTimeFrom:string = null;
    private dateTimeTo:string = null;    
    datesDidSelect(dateTimeFrom, dateTimeTo) {
        this.dateTimeFrom = MIODateGetDateString(dateTimeFrom) + " 00:00:00";
        this.dateTimeTo = MIODateGetDateString(dateTimeTo) + " 23:59:59";
        
        //this.showNoItemSelectedView();
        this.setFetchedResultsController(null);
        this.tableView.reloadData();
	}
	
	private _filters = null;
    get filters(){
        if (this._filters != null) return this._filters;

        this._filters = [
                FilterOption.filterWithTitle("FromDate", "From day", "date", FilterFieldType.Date, null, FilterControllerComparatorType.MajorOrEqualComparator, null, "00:00:00"),
				FilterOption.filterWithTitle("ToDate", "To day", "date", FilterFieldType.Date, null, FilterControllerComparatorType.MinorOrEqualComparator, null, "23:59:59"),
				FilterOption.filterWithTitle("Amount", "Amount", "totalPrice", FilterFieldType.Number, null, null),            
                FilterOption.filterWithFetchRequest("Client", "Client", "legalEntity.identifier", FilterFieldType.DropDown, "Client", "name", "identifier", MIOLocalizeString("SELECT_CLIENT", "Select Client"))];                
        return this._filters;
	}
	
	protected filterPredicateFormat:string = null;
    protected filtersDidChange(filtersPredicateFormat){
        if(filtersPredicateFormat != null) {
            MUICoreLayerAddStyle(this.filterButton.layer, 'filter');
            MUICoreLayerRemoveStyle(this.filterButton.layer, 'filter-off');
        } else {
            MUICoreLayerRemoveStyle(this.filterButton.layer, 'filter');
            MUICoreLayerAddStyle(this.filterButton.layer, 'filter-off');
        }

        this.filterPredicateFormat = filtersPredicateFormat;
        this.setFetchedResultsController( null );
        this.tableView.reloadData();
	}

    protected showLegalEntitySelectionViewController( numberSequence:NumberSerialSequence = null, type:LegalEntityDefaultSelectionType = LegalEntityDefaultSelectionType.client, userInfo:any = null ) {
        AppHelper.sharedInstance().showLegalEntitySelectionViewController( numberSequence, type, userInfo, ( entity:LegalEntity, numberSequence: NumberSerialSequence, userInfo:any ) => this.createNewInvoice(entity, numberSequence, userInfo) );
    }

    protected createNewInvoice( entity:LegalEntity, numberSequence: NumberSerialSequence, userInfo:any ) {}
    protected addInvoice() {}

}